var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareLine = function SvgSquareLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 4.375h10c.345 0 .625.28.625.625v10c0 .345-.28.625-.625.625H5A.625.625 0 0 1 4.375 15V5c0-.345.28-.625.625-.625m.625 1.25v8.75h8.75v-8.75z"
  })));
};
export default SvgSquareLine;